// extracted by mini-css-extract-plugin
module.exports = {"block":"NascarBar_block__SjzXb","nascarImage":"NascarBar_nascarImage__Eeypu"};